import { useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getEpikBoxData } from '../../actions/EpikBoxes';
import utils from '../../lib/utils';

export const useRefreshBox = boxID => {
  const dispatch = useDispatch();

  const tokenRef = useRef(null);

  useEffect(() => {
    if (!tokenRef.current) {
      tokenRef.current = utils.getAuthToken();
    }
  }, []);

  const refreshBoxData = useCallback(() => {
    const { current: token } = tokenRef;
    dispatch(getEpikBoxData(token, boxID));
  }, [boxID]);

  return {
    refreshBoxData,
  };
};
